import { PayloadAction, createReducer } from 'typesafe-actions';
import { Building } from '../../types';
import {
  CLEAR_BUILDINGS,
  GET_BUILDINGS_FAILURE,
  GET_BUILDINGS_REQUEST,
  GET_BUILDINGS_SUCCESS,
} from '../actions/getBuildings';

export interface BuildingsState {
  isLoading: boolean;
  list: Building[];
  query: string;
  errorMessage: Error | undefined;
}

const initialState: BuildingsState = {
  isLoading: false,
  list: [],
  query: '',
  errorMessage: undefined,
};

export const buildings = createReducer<BuildingsState>(initialState)
  .handleAction(
    CLEAR_BUILDINGS,
    (): BuildingsState => ({
      ...initialState,
    }),
  )
  .handleAction(
    GET_BUILDINGS_REQUEST,
    (state: BuildingsState): BuildingsState => ({
      ...state,
      isLoading: true,
    }),
  )
  .handleAction(
    GET_BUILDINGS_SUCCESS,
    (
      state: BuildingsState,
      action: PayloadAction<string, Building[]>,
    ): BuildingsState => ({
      ...state,
      isLoading: false,
      list: action.payload,
    }),
  )
  .handleAction(
    GET_BUILDINGS_FAILURE,
    (
      state: BuildingsState,
      action: PayloadAction<string, Error>,
    ): BuildingsState => ({
      ...state,
      isLoading: false,
      errorMessage: action.payload,
    }),
  );
